import { palette } from '../global/palette';
import { shape } from '../global/shape';
import type { ComponentOverride } from '../types';

export const MuiAccordionDetails: ComponentOverride<'MuiAccordionDetails'> = {
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        backgroundColor: palette.grey['200'],
        borderBottomLeftRadius: shape.borderRadius,
        borderBottomRightRadius: shape.borderRadius,
        padding: '0 24px 24px 24px',
      },
    },
  },
};
